import { UsageEventType } from '@unity-learning/shared';
import { apiPost } from '../services/api';

/**
 * A8 — Analytics minimales d'usage.
 * Fire-and-forget : jamais d'await bloquant, jamais d'erreur visible en console —
 * l'analytics ne doit jamais casser l'UX. L'identification se fait côté serveur
 * via le cookie JWT (credentials: 'include') ; sans cookie valide l'événement est ignoré.
 * keepalive : la requête part même si l'utilisateur navigue juste après le clic.
 */
export function trackEvent(eventType: UsageEventType, metadata?: Record<string, unknown>): void {
  try {
    apiPost('/api/events', { eventType, ...(metadata ? { metadata } : {}) }, { keepalive: true }).catch(() => {
      // Silencieux : échec réseau = événement perdu, tant pis
    });
  } catch {
    // Silencieux : jamais d'exception remontée à l'appelant
  }
}
